import { Injectable } from '@angular/core';
import { Baseservice } from './baseservice';
import { environment } from 'environments/environment';
import { AuthenticationService } from './authentication.service';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PassengerListServiceService {

  protected url: string = environment.iCBMSWebApi.url;

  constructor(private http: HttpClient) { }
  
    savePassenger(body)
    {
      return this.http.post(this.url + 'CompliancePassengerList/add',body);
    }
    updatePassenger(body)
    {
      return this.http.put(this.url + 'CompliancePassengerList/update',body);
    }
    getPassengersByTripId(tripId){
      return this.http.get(this.url + 'compliance/getCompliancePassengerList/'+tripId);
    }
    deletePassenger(id){
      return this.http.delete(this.url + 'compliance/deleteCompliancePassengerList/'+id);
    }

    getTripDetails(tripId){
      return this.http.get(this.url + 'compliance/getComplianceTrip/'+tripId);
    }

    getReturnDetails(compliance_return_id){
      return this.http.get(this.url + 'compliance/getReturnDetails/'+compliance_return_id);
    }
}
